import React, { useRef, useEffect } from 'react';
import { isVideo } from './worksData';

// Affiche indifféremment une image ou une vidéo (muette, en boucle).
// Les vidéos ne jouent que lorsqu'elles sont visibles à l'écran :
// hors du champ de vision, elles sont mises en pause pour économiser
// le processeur/GPU (évite les saccades quand il y a beaucoup de médias).
export default function WorkVisual({ src, alt, className, style }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.01 }
    );
    observer.observe(video);
    return () => observer.disconnect();
  }, [src]);

  if (isVideo(src)) {
    return (
      <video
        ref={videoRef}
        key={src}
        src={src}
        className={className}
        style={style}
        muted
        loop
        playsInline
        preload="metadata"
      />
    );
  }
  return <img src={src} alt={alt || ''} className={className} style={style} />;
}
